<template>
  <div>
    <v-container fluid>
      <v-row align="center" justify="space-between" class="font-weight-black">
        <v-col cols="12" sm="11">
          <v-breadcrumbs :items="breadcrumbs" divider="/" v-if="!omiteBreadcrumbs">
            <template v-slot:item="props">
              <v-breadcrumbs-item
                :disabled="props.item.disabled"
                :class="{
                  'ApuracaoContrato_breadcrumbs-item': true,
                  'ApuracaoContrato_breadcrumbs-item_disabled': props.item.disabled,
                }">
                {{ props.item.text }}
              </v-breadcrumbs-item>
            </template>
          </v-breadcrumbs>
        </v-col>
        <v-spacer></v-spacer>
        <v-col cols="12" sm="1" class="text-right" v-if="exibirFiltro">
          <v-badge
              bordered
              color="orange"
              icon="mdi-lock"
              overlap
              v-show="!abrirFiltro"
              v-if="habilitarIconBadge">
              <v-icon v-show="!abrirFiltro" @click="abrirFiltro = !abrirFiltro">filter_list</v-icon>
          </v-badge>
          <v-icon v-else v-show="!abrirFiltro" @click="abrirFiltro = !abrirFiltro">filter_list</v-icon>
        </v-col>
      </v-row>
    </v-container>

    <apuracao-contrato-filtros
      ref="filtrosComplementares"
      v-model="abrirFiltro"
      :desabilita-aplicar="desabilitaAplicar"
      :filtros-complementares="filtrosComplementares"
      @ApuracaoContratoFiltros__AplicaFiltros="aplicarFiltros"
      @ApuracaoContratoFiltros_conteinerCarregado="abrirTooltip"
      @FiltroRapido__HabilitaIconBadge="habilitaIconBadge">
    </apuracao-contrato-filtros>

    <apuracao-contrato-filtros-obrigatorios
      @ApuracaoContratoFiltrosObrigatorios__AplicaFiltros="aplicarFiltrosObrigatorios"
      @ApuracaoContratoFiltrosObrigatorios__FiltrosObrigatoriosPreenchidos="filtrosObrigatoriosPreenchidos"
      @ApuracaoContratoFiltrosObrigatorios__IndExibirApuracoesZeradasAlterado="handleIndExibirApuracoesZeradasAlterado"
    />
    <div class="card-title ml-9" style="font-size: 14px; font-weight:normal;">
      {{ $t('message.filtrar_apuracao_contrato') }}
    </div>

    <apuracao-contrato-tabs
      ref="tabs"
      :totalizadores-periodos="totalizadoresPeriodos"
      :apuracoes="apuracoes"
      :total-page="totalPage"
      :desabilita-tabs="desabilitaAplicar"
      :selecionar-item="selecionarItem"
      :verificaRetornaDatasValidas="verificaRetornaDatasValidas"
      :montar-data-inicio-fim-edicao-valores="montarDataInicioFimApuracao"
      :lista-tipos-uso="listaTiposUso"
      :filtros="filtros"
      :finalizar-apuracao="finalizarApuracao"
      @ApuracaoContratoTabData__cancelaApuracaoListaSelecionada="cancelaApuracaoListaSelecionada"
      @ApuracaoContratoFiltrosObrigatorios__AplicaFiltros="aplicarFiltrosObrigatorios">
    </apuracao-contrato-tabs>
    <v-container pt-6 fluid v-resize="onResize">
    <v-row>

      <v-footer
          class="pt-6"
          v-bind="{fixed: true}"
          :style="`width: ${tamanhoRodape}px; background-color: #EEEEEE; min-height: 80px;`"
      >
        <apuracao-contrato-modal-tipo-uso-massivo
          :lista-tipos-uso="listaTiposUso"
          :apuracoes-selecionadas="apuracoesSelecionadas"
          :existe-apuracoes-selecionadas="existeApuracoesSelecionadas"
          @ApuracaoContratoModalTipoUsoMassivo__atualizaTabela="atualizaTabela">
        </apuracao-contrato-modal-tipo-uso-massivo>

        <v-spacer v-if="!xs"></v-spacer>
        <div v-if="indExibirApuracoesZeradas">
          <v-btn class="mr-2 my-auto"
            v-if="indCancelarOuFinalizarSelecionados"
            @click="cancelarSelecionados(botaoCancelarSelecionados)">
            {{ $t('label.cancelar_selecionados') }} {{ apuracoesSelecionadas.length }}
          </v-btn>

          <v-tooltip v-if="apuracoes.length" top>
            <template v-slot:activator="{ on, attrs }">
              <v-btn
                class="mr-15 my-auto mr-3"
                color="primary"
                v-bind="attrs"
                v-on="on"
                @click="cancelarTudo">
                {{ $t('label.cancelar_tudo') }} {{ apuracoes.length }}
              </v-btn>
            </template>
            <span>{{ $t('message.cancelar_todos_registros_da_pagina')}}</span>
          </v-tooltip>
        </div>
        <div v-else>
          <v-btn class="mr-2 my-auto"
            v-if="indCancelarOuFinalizarSelecionados"
            @click="finalizarSelecionados">
            {{ $t('label.finalizar_selecionados') }}
          </v-btn>
          <v-tooltip v-if="apuracoes.length" top>
            <template v-slot:activator="{ on, attrs }">
              <v-btn
                class="mr-15 my-auto mr-3"
                color="primary"
                v-bind="attrs"
                v-on="on"
                @click="finalizarTudo">
                {{ $t('label.finalizar_tudo') }}
              </v-btn>
            </template>
            <span>{{ $t('message.finalizar_todos_registros_da_pagina') }}</span>
          </v-tooltip>
        </div>
      </v-footer>
    </v-row>
    </v-container>

    <dialog-finalizar-apuracoes
      ref="modalFinalizarApuracoes"
      :apuracoes-inconsistentes="apuracoesInconsistentes"
      :apuracao-inconsistentes-parciais="apuracaoInconsistentesParciais"
      @agree="finalizarApuracoes">
  </dialog-finalizar-apuracoes>

  <v-dialog v-model="dialogCancelamento" persistent max-width="650px">
    <v-card>
      <v-card-title class="pl-3">
          <span class="text-h6 font-weight-bold text-uppercase">
            {{ $t('title.cancelar_apuracoes') }}
          </span>
      </v-card-title>

      <v-row class="px-3">
        <v-col cols="12" class="pt-2">
          <span class="text-body-2">
            <strong>{{ $t('label.atencao') }}:</strong>
            {{ $t('message.confirmacao_apuracoes_selecionadas_para_cancelamento') }}
          </span>
        </v-col>

        <v-col cols="12" class="pt-2">
          <span v-html="`${$t('label.total_de_apuracoes_a_serem_canceladas')}`" class="text-body-2" ></span>
          <b>{{ this.indCancelarTodasApuracoes ? apuracoes.length: apuracoesSelecionadas.length }}</b>
        </v-col>

        <v-col cols="12" class="pt-0">
          <span class="text-body-2">
            {{ $t('label.informe_justificativa') }}:
          </span>
        </v-col>

        <v-col cols="12" class="pt-0">
          <span class="text-body-2 d-block text-decoration-underline">
            {{ $t('label.apuracoes_sem_valor_para_arrecadacao') }}
          </span>
          <span class="caption grey--text">
            {{ $t('message.todos_registros_com_justificativa_cancelamento') }}
          </span>
        </v-col>
      </v-row>

      <v-card-actions>
        <v-spacer></v-spacer>
        <v-btn color="secundary" @click="fechaModalCancelamento()">
          {{ $t('label.cancelar') }}
        </v-btn>
        <v-btn
          color="primary"
          @click="confirmarCancelamentoApuracoes()"
        >
          {{ $t('label.ok') }} ({{ this.indCancelarTodasApuracoes ? apuracoes.length: apuracoesSelecionadas.length }})
        </v-btn>
      </v-card-actions>
    </v-card>
  </v-dialog>
  </div>
</template>

<script>
import { mapActions, mapGetters } from 'vuex';
import moment from 'moment';
import { generateComputed } from '@/common/functions/roles-computed-generator';
import { forceLoading, forceHideLoading } from '@/common/functions/loading';
import ApuracaoContratoFiltros from '@/spa/apuracao-contrato/ApuracaoContratoFiltros';
import ApuracaoContratoFiltrosObrigatorios from '@/spa/apuracao-contrato/ApuracaoContratoFiltrosObrigatorios';
import ApuracaoContratoTabs from '@/spa/apuracao-contrato/ApuracaoContratoTabs';
import PlanejamentoContratoListCards from '@/spa/planejamento-contrato/list/PlanejamentoContratoListCards';
import ApuracaoContratoControleBreadcrumbs from '@/spa/apuracao-contrato/ApuracaoContratoControleBreadcrumbs';
import ApuracaoContratoModalTipoUsoMassivo from '@/spa/apuracao-contrato/modals/ApuracaoContratoModalTipoUsoMassivo';
import DialogFinalizarApuracoes from '@/spa/apuracao-contrato/modals/DialogFinalizarApuracoes';
import {
  buscarApuracaoFornecedorPorContrato,
  buscarTotalizadoresPeriodoApuracao,
  finalizarApuracaoLoteFornecedor,
} from '@/common/resources/apuracao-contrato';
import {
  formatlastDayOfTheMonth,
  formatFirstDayOfTheMonth,
} from '@/common/functions/date-utils';

export default {
  name: 'ApuracaoContrato',
  components: {
    PlanejamentoContratoListCards,
    ApuracaoContratoFiltros,
    ApuracaoContratoFiltrosObrigatorios,
    ApuracaoContratoTabs,
    ApuracaoContratoModalTipoUsoMassivo,
    DialogFinalizarApuracoes,
  },
  mixins: [ApuracaoContratoControleBreadcrumbs],
  data() {
    return {
      apuracaoAcaoResource: this.$api.apuracaoAcaoEdicao(this.$resource),
      workflowAcaoMagaluResource: this.$api.workflowAcaoMagalu(this.$resource),
      resourceApuracaoContratoParcial: this.$api.apuracaoContratoParcial(this.$resource),
      abrirFiltro: false,
      omiteBreadcrumbs: false,
      aplicarFiltroNoCarregamento: true,
      filtros: {},
      filtrosComplementares: {},
      habilitarIconBadge: false,
      showTooltip: false,
      tamanhoFiltros: 0,
      desabilitaAplicar: true,
      indCancelarOuFinalizarTudo: false,
      apuracoes: [],
      totalPage: 0,
      tabSelecionada: '',
      apuracoesSelecionadas: [],
      apuracoesInconsistentes: [],
      apuracaoInconsistentesParciais: [],
      listaTiposUso: [],
      totalizadoresPeriodos: {
        mensal: 0,
        semestral: 0,
        trimestral: 0,
        anual: 0,
      },
      pagination: {
        itemsPerPage: 10,
        page: 1,
      },
      tamanhoTela: window.innerWidth,
      ordenacao: '',
      asc: '',
      deveZerarSelecionados: false,
      indExibirApuracoesZeradas: false,
      dialogCancelamento: false,
      botaoCancelarTudo: 'cancelar tudo',
      botaoCancelarSelecionados: 'cancelar selecionados',
      indCancelarTodasApuracoes: false,
    };
  },
  computed: {
    ...generateComputed('APU_CONTR', [
      'canAccessPage',
    ]),
    ...mapGetters('implantacao', [
      'chaveEmpresa',
    ]),
    isAmbienteKabum() {
      return this.chaveEmpresa === 'KABUM';
    },
    xs() {
      return this.$vuetify.breakpoint.xs;
    },
    lg() {
      return this.$vuetify.breakpoint.lgAndUp;
    },
    tamanhoRodape() {
      return this.tamanhoTela - (this.abrirFiltro && this.lg ? this.tamanhoFiltros : 0);
    },
    existeApuracoesSelecionadas() {
      return this.apuracoesSelecionadas.filter((a) => a.selecionado).length > 0;
    },
    indCancelarOuFinalizarSelecionados() {
      return !this.indCancelarOuFinalizarTudo
        && (this.apuracoesSelecionadas.length);
    },
  },
  watch: {
    exibirFiltro(val) {
      if (val) {
        setTimeout(() => this.$refs.totalizadores.aplicaFiltros(this.filtros),
          3E2);
      }
    },
  },
  methods: {
    ...mapActions('filtros', [
      'setFiltroApuracaoContrato',
      'setFiltroApuracaoContratoNivel1',
    ]),
    accessForbidden() {
      if (!this.canAccessPage) {
        this.$router.push({ name: 'inicio' });
        this.$toast(this.$t('message.acesso_negado'));
      }
    },
    onResize() {
      this.tamanhoTela = window.innerWidth;
    },
    cancelaApuracaoListaSelecionada(idApuracao) {
      this.apuracoesSelecionadas = this.apuracoesSelecionadas.filter((a) => a.idApuracao !== idApuracao);
    },
    selecionarItem(itemSelecionado, e) {
      if (e) e.stopPropagation();
      const apuracaoSelecionada = this.apuracoesSelecionadas.find((a) => a.idApuracao === itemSelecionado.idApuracao);
      if (apuracaoSelecionada) {
        const index = this.apuracoesSelecionadas.findIndex((a) => a.idApuracao === itemSelecionado.idApuracao);
        this.apuracoesSelecionadas.splice(index, 1);
      }
      if (itemSelecionado.selecionado) {
        this.apuracoesSelecionadas.push(itemSelecionado);
      }
    },
    aplicarFiltros(filtrosLaterais, mudouFiltrosLaterais, isBuscaFiltroLateral = false) {
      this.indExibirApuracoesZeradas = this.filtros.indExibirApuracoesZeradas;
      this.filtrosComplementares = filtrosLaterais;
      if (isBuscaFiltroLateral) {
        this.pagination.page = 1;
      }
      if (this.tabSelecionada && mudouFiltrosLaterais) {
        const params = this.formatarFiltros(this.filtros, this.filtrosComplementares);
        params.periodo_apuracao = this.tabSelecionada.toUpperCase();
        params.asc = this.asc;
        params.colunaOrdenacao = this.ordenacao;
        this.buscarApuracoes(params);
      } else {
        this.buscarTotalizadores(this.formatarFiltros(this.filtros, this.filtrosComplementares));
      }
      if (this.$refs.tabs.tabSelecionada) {
        const nomRef = this.$refs.tabs.tabSelecionada;
        if (this.$refs.tabs.$refs[nomRef]) {
          this.$refs.tabs.$refs[nomRef].resetarExpanded();
        }
      }
      this.abrirFiltro = false;
    },
    aplicarFiltrosObrigatorios(paginationTab, tabSelecionada, zerarSelecionadas = false) {
      this.tabSelecionada = tabSelecionada;
      this.apuracoes = [];
      if (this.$refs.tabs.tabSelecionada) {
        const nomRef = this.$refs.tabs.tabSelecionada;
        if (this.$refs.tabs.$refs[nomRef]) {
          this.$refs.tabs.$refs[nomRef].resetarExpanded();
        }
      }

      if (zerarSelecionadas) {
        this.apuracoesSelecionadas = [];
        this.deveZerarSelecionados = true;
      } else {
        this.deveZerarSelecionados = false;
      }
      if (paginationTab) {
        this.$refs.filtrosComplementares.setarIsPaginacaoAlterada(true);
        this.pagination = paginationTab;
        if (this.pagination.sortBy && this.pagination.sortBy.length) {
          const { sortBy, sortDesc } = this.pagination;
          this.asc = !sortDesc[0];
          this.ordenacao = this.formatarOrdenacaoPorValor(sortBy);
        }
      } else {
        this.pagination.page = 1;
        this.$refs.filtrosComplementares.setarIsPaginacaoAlterada(false);
      }
      if (!this.desabilitaAplicar) {
        this.$refs.filtrosComplementares.$refs.filtrosRapidos.aplicar();
      }
    },
    filtrosObrigatoriosPreenchidos(filtrosObrigatorios) {
      if (filtrosObrigatorios) {
        this.filtros = filtrosObrigatorios;
        this.desabilitaAplicar = false;
      } else if (!filtrosObrigatorios && filtrosObrigatorios !== undefined) {
        this.desabilitaAplicar = true;
      }
      this.apuracoes = [];
      this.totalizadoresPeriodos = {
        mensal: 0,
        semestral: 0,
        trimestral: 0,
        anual: 0,
      };
    },
    formatarOrdenacaoPorValor(sortBy) {
      if (sortBy && sortBy.length) {
        const valor = sortBy[0];
        if (valor === 'periodoVigencia' && this.$refs.tabs.tabSelecionada === 'tab-mensal') {
          return 'dc.data_inicio';
        }
        if (valor === 'periodoVigencia' && this.$refs.tabs.tabSelecionada !== 'tab-mensal') {
          return 'dc.datas_parciais';
        }
        let valorFormatado = valor.replace(/([A-Z])/g, '_$1').toLowerCase();
        valorFormatado = `dc.${valorFormatado}`;
        return valorFormatado;
      }
      return null;
    },
    abrirTooltip() {
      setTimeout(() => {
        this.showTooltip = true;
      }, 1000);
      this.tamanhoFiltros = document.getElementById('ApuracaoFiltros__filtro_rapido').offsetWidth;
    },
    buscarTotalizadores(params) {
      return buscarTotalizadoresPeriodoApuracao(params, this.$resource)
        .then((response) => {
          if (response.body) {
            this.totalizadoresPeriodos = this.formatarTotalizadores(response.body);
            params.periodo_apuracao = this.verificaMaiorPeriodo(this.totalizadoresPeriodos).toUpperCase();
            this.tabSelecionada = params.periodo_apuracao;
            if (params.periodo_apuracao) {
              setTimeout(() => {
                this.buscarApuracoes(params);
              }, 2E2);
            } else {
              this.apuracoes = [];
              this.totalPage = 0;
            }
          }
        })
        .catch((err) => {
          this.$error(this, err);
        });
    },
    buscarApuracoes(params) {
      if (this.deveZerarSelecionados) {
        this.apuracoesSelecionadas = [];
      }
      return buscarApuracaoFornecedorPorContrato(params, this.$resource)
        .then((response) => {
          this.asc = '';
          this.ordenacao = '';
          this.apuracoes = response.data.resposta || [];
          if (params.periodo_apuracao !== 'MENSAL' && this.apuracoes.length) {
            this.apuracoes.forEach((apuracao) => {
              const dataParcial = this.verificaRetornaDatasValidas(apuracao);
              if (dataParcial.length) {
                apuracao.dataParcialFormatada = this.formatarDataParcial(dataParcial);
              } else {
                apuracao.dataParcialFormatada = {
                  resultado: null,
                  abrirModal: null,
                };
              }
            });
          }
          if (this.apuracoesSelecionadas && this.apuracoesSelecionadas.length) {
            this.apuracoes.forEach((apuracao) => {
              const apuracaoSelect = this.apuracoesSelecionadas.find((apuracaoSelecionada) => apuracaoSelecionada.idContrato === apuracao.idContrato
                 && apuracaoSelecionada.idApuracao === apuracao.idApuracao
                 && apuracaoSelecionada.idAcao === apuracao.idAcao);
              if (apuracaoSelect) {
                apuracao.selecionado = true;
              } else {
                apuracao.selecionado = false;
              }
            });
          }
          this.totalPage = response.data.quantidadeRegistrosPagina;
          if (response.data.resposta) {
            this.$refs.tabs.tabSelecionada = this.buscarTabSelecionada(params.periodo_apuracao);
          }
        })
        .catch((err) => {
          this.$error(this, err);
        });
    },
    verificaMaiorPeriodo(obj) {
      let maior = -Infinity;
      let chave = '';
      Object.keys(obj).forEach((el) => {
        if (obj[el] > maior && obj[el] !== 0) {
          maior = obj[el];
          chave = el;
        }
      });
      return chave;
    },
    formatarTotalizadores(total) {
      const totalizadores = {
        mensal: 0,
        trimestral: 0,
        semestral: 0,
        anual: 0,
      };
      total.forEach((el) => {
        if (el.periodoApuracao === 'MENSAL') {
          totalizadores.mensal = el.totalPeriodo;
        }
        if (el.periodoApuracao === 'TRIMESTRAL') {
          totalizadores.trimestral = el.totalPeriodo;
        }
        if (el.periodoApuracao === 'SEMESTRAL') {
          totalizadores.semestral = el.totalPeriodo;
        }
        if (el.periodoApuracao === 'ANUAL') {
          totalizadores.anual = el.totalPeriodo;
        }
      });
      return totalizadores;
    },
    buscarTabSelecionada(periodo) {
      let tab = '';
      switch (periodo) {
        case 'MENSAL':
          tab = 'tab-mensal';
          break;
        case 'TRIMESTRAL':
          tab = 'tab-trimestral';
          break;
        case 'SEMESTRAL':
          tab = 'tab-semestral';
          break;
        case 'ANUAL':
          tab = 'tab-anual';
          break;
        default:
          tab = 'tab-mensal';
          break;
      }
      return tab;
    },
    formatarDataParcial(dataParcial) {
      const meses = [
        'JANEIRO', 'FEVEREIRO', 'MARÇO', 'ABRIL',
        'MAIO', 'JUNHO', 'JULHO', 'AGOSTO',
        'SETEMBRO', 'OUTUBRO', 'NOVEMBRO', 'DEZEMBRO',
      ];

      if (dataParcial.length === 1) {
        const [ano, mes] = dataParcial[0].split('-');
        const mesFormatado = meses[parseInt(mes, 10) - 1];
        const anoFormatado = ano.slice(-2);
        return {
          resultado: `${mesFormatado}/${anoFormatado}`,
          consecutivo: true,
          unicoMes: true,
          abrirModal: false,
        };
      }

      const mesesIncluidos = dataParcial.map((data) => {
        const [, mes] = data.split('-');
        return parseInt(mes, 10);
      });

      const anoInicial = dataParcial[0].split('-')[0];
      const anoFinal = dataParcial[dataParcial.length - 1].split('-')[0];

      const mesesContinuos = [];
      for (let i = mesesIncluidos[0]; i <= mesesIncluidos[mesesIncluidos.length - 1]; i += 1) {
        mesesContinuos.push(i);
      }

      const mesInicialFormatado = meses[mesesIncluidos[0] - 1];
      const mesFinalFormatado = meses[mesesIncluidos[mesesIncluidos.length - 1] - 1];

      let resultado = `${mesInicialFormatado}/${anoInicial.slice(-2)}`;
      let consecutivo = false;
      let unicoMes = false;
      let abrirModal = true;

      // Verificar se os meses são consecutivos
      if (anoInicial !== anoFinal || mesesIncluidos.length > 1) {
        // Se todos os meses estão incluídos consecutivamente
        if (mesesIncluidos.length === mesesContinuos.length) {
          resultado += ` a ${mesFinalFormatado}/${anoFinal.slice(-2)}`;
          consecutivo = true;
          abrirModal = false;
        } else {
          // Se os meses não são consecutivos
          for (let i = 1; i < mesesIncluidos.length - 1; i += 1) {
            const mesAtual = mesesIncluidos[i];
            const mesAtualFormatado = meses[mesAtual - 1];
            resultado += `, ${mesAtualFormatado}/${anoInicial.slice(-2)}`;
          }
          resultado += `, ${mesFinalFormatado}/${anoFinal.slice(-2)}`;
        }
      }

      // Verificar se é um único mês
      if (mesesIncluidos.length === 1) {
        unicoMes = true;
        abrirModal = false;
      }

      return {
        resultado,
        consecutivo,
        unicoMes,
        abrirModal,
      };
    },
    habilitaIconBadge(valor) {
      this.habilitarIconBadge = valor;
    },
    formatarFiltros(filtros, filtrosComplementares) {
      const filtrosFormatados = {
        ...filtrosComplementares,
        id_acao_tipo: filtros.tipoAcao,
        exibir_apuracoes_com_valor_zero: filtros.indExibirApuracoesZeradas,
        data_inicio_apuracao: moment(filtros.dataInicio, 'YYYY-MM').format('YYYY-MM-DD'),
        data_fim_apuracao: formatlastDayOfTheMonth(moment(filtros.dataFim, 'YYYY-MM').format('MM-YYYY'), 'YYYY-MM-DD'),
        ids_categoria: this.extrairIds(filtros.categoria),
        status: this.montarFiltrosStatus(filtrosComplementares),
        tamanhoPagina: this.pagination.itemsPerPage,
        numeroPagina: this.pagination.page,
      };
      return filtrosFormatados;
    },
    montarFiltrosStatus(filtrosComplementares) {
      const filtrosStatus = ['AGUARDANDO_APURACAO'];
      if (filtrosComplementares.apresentar_apuracoes_finalizadas) {
        filtrosStatus.push('APROVADO');
      }
      if (filtrosComplementares.apresentar_apuracoes_canceladas) {
        filtrosStatus.push('CANCELADO');
      }
      return filtrosStatus;
    },
    extrairIds(array) {
      if (!array.length) {
        return null;
      }
      return array.map((el) => el.id);
    },
    buscarTiposUso() {
      const params = {
        indTipoUsoContrato: true,
      };
      this.workflowAcaoMagaluResource
        .buscarTiposUso(params)
        .then((res) => {
          this.listaTiposUso = res.data;
        })
        .catch((err) => {
          this.$toast(err.data.error);
        });
    },
    atualizaTabela(idTipoUsoNovo) {
      const tipoUsoNovo = this.listaTiposUso.find((el) => el.id === idTipoUsoNovo);
      this.apuracoes.forEach((apuracao1) => {
        this.apuracoesSelecionadas.forEach((apuracao2) => {
          if (apuracao1.idApuracao === apuracao2.idApuracao) {
            apuracao1.tipoUsoNovo = tipoUsoNovo.nome;
            apuracao1.idTipoUsoNovo = idTipoUsoNovo;
            apuracao1.selecionado = false;
          }
        });
      });
      const nomRef = this.$refs.tabs.tabSelecionada;
      this.$refs.tabs.$refs[nomRef].reRenderizarTable();
      this.apuracoesSelecionadas = [];
    },
    async finalizarTudo() {
      this.apuracoesSelecionadas = this.apuracoes;
      await this.finalizarSelecionados();
    },
    async cancelarTudo() {
      await this.cancelarSelecionados(this.botaoCancelarTudo);
    },
    cancelarSelecionados(botaoSelecionado) {
      if (botaoSelecionado === this.botaoCancelarTudo) {
        this.indCancelarTodasApuracoes = true;
      }
      setTimeout(this.dialogCancelamento = true);
    },
    fechaModalCancelamento() {
      this.indCancelarSelecao = false;
      this.indCancelarTodasApuracoes = false;
      this.dialogCancelamento = false;
    },
    confirmarCancelamento() {
      this.fechaModalCancelamento();
    },
    confirmarCancelamentoApuracoes() {
      if (this.indCancelarTodasApuracoes) {
        this.apuracoesSelecionadas = this.apuracoes;
      }
      const listaIdsApuracao = this.apuracoesSelecionadas.map((apuracao) => apuracao.idApuracao);
      const justificativaCancelamento = this.$tc('label.apuracoes_sem_valor_para_arrecadacao');

      this.apuracaoAcaoResource.cancelarApuracoes({ justificativaCancelamento }, listaIdsApuracao)
        .then(() => {
          listaIdsApuracao.forEach((idApuracao) => {
            const index = this.apuracoes.findIndex((a) => a.idApuracao === idApuracao);
            this.apuracoes.splice(index, 1);
          });
          this.$toast(this.$t('message.apuracao_cancelada_sucesso'));
          this.apuracoesSelecionadas = [];
          this.fechaModalCancelamento();
          const nomRef = this.$refs.tabs.tabSelecionada;
          this.$refs.tabs.$refs[nomRef].reRenderizarTable();
        })
        .catch((err) => {
          this.$error(this, err);
        });
    },
    async finalizarApuracao(apuracao) {
      apuracao.selecionado = true;
      this.apuracoesSelecionadas.push(apuracao);
      await this.finalizarSelecionados();
    },
    finalizarSelecionados() {
      this.apuracoesInconsistentes = [];
      this.apuracaoInconsistentesParciais = [];

      this.apuracoesSelecionadas.forEach((a) => {
        if (this.apuracaoPossuiInconsistencia(a)) {
          this.apuracoesInconsistentes.push(a);
        }
        if (this.apuracaoPossuiInconsistenciaApuracoes(a)) {
          this.apuracaoInconsistentesParciais.push(a);
        }
      });
      this.apuracoesSelecionadas = this.apuracoesSelecionadas.filter((a) => !this.apuracaoPossuiInconsistencia(a) && a.statusApuracao !== 'APROVADO');
      this.apuracoesSelecionadas = this.apuracoesSelecionadas.filter((a) => !this.apuracaoPossuiInconsistenciaApuracoes(a));
      setTimeout(() => this.$refs.modalFinalizarApuracoes.open(this.apuracoesSelecionadas));
    },
    finalizarApuracoes(dataContabilizacao) {
      forceLoading();
      if (this.tabSelecionada.toUpperCase() === 'MENSAL') {
        this.finalizarApuracoesIntegral();
      } else {
        const apuracoesFinalizadas = [];
        this.apuracoesSelecionadas
          .forEach((apuracao) => {
            apuracoesFinalizadas.push(this.prepararParcial(apuracao, dataContabilizacao));
          });
        if (apuracoesFinalizadas.length) {
          this.finalizarParcial(this.removerApuracoesDuplicadas(apuracoesFinalizadas));
        } else {
          forceHideLoading();
        }
      }
    },
    removerApuracoesDuplicadas(apuracoesFinalizadas) {
      const setApuracao = new Set();
      const filterApuracao = apuracoesFinalizadas.filter((apuracao) => {
        const apuracaoDuplicas = setApuracao.has(apuracao.idApuracao);
        setApuracao.add(apuracao.idApuracao);
        return !apuracaoDuplicas;
      });
      return filterApuracao;
    },
    finalizarApuracoesIntegral() {
      const filtros = this.prepararParametros();
      delete filtros.todasCategorias;
      finalizarApuracaoLoteFornecedor(filtros, this.$resource)
        .then(() => {
          this.aplicarFiltrosObrigatorios();
          this.$refs.modalFinalizarApuracoes.close();
          this.$toast(this.$tc('message.apuracao_finalizada_sucesso', 2));
          this.apuracoesSelecionadas = [];
          forceHideLoading();
        })
        .catch((err) => {
          forceHideLoading();
          this.$error(this, err);
          this.$refs.modalFinalizarApuracoes.close();
        });
    },
    finalizarParcial(apuracoesFinalizadas) {
      this.resourceApuracaoContratoParcial.gravar(apuracoesFinalizadas)
        .then(() => {
          this.aplicarFiltrosObrigatorios();
          this.$refs.modalFinalizarApuracoes.close();
          this.$toast(this.$tc('message.apuracao_finalizada_sucesso', 2));
          this.apuracoesSelecionadas = [];
          forceHideLoading();
        })
        .catch((err) => {
          forceHideLoading();
          this.$error(this, err);
        });
    },
    prepararParcial(apuracao, dataContabilizacao) {
      let finalizaApuracao = false;
      let indCriaRecebimento = true;

      if (apuracao.recebimentoDefinido > 0 && (this.periodoIntegralApuracao(apuracao) || this.indTodosMesesVigentes(apuracao))) {
        finalizaApuracao = true;
      }

      if (this.isformaBonificacaoFixo(apuracao)
          && (parseFloat(apuracao.recebimentoAtual).toFixed(2) === parseFloat(apuracao.recebimentoDefinido + apuracao.vlrNdGerado).toFixed(2))) {
        finalizaApuracao = true;
      }

      if (apuracao.vlrNdGerado > 0 && apuracao.recebimentoDefinido === 0 && (this.periodoIntegralApuracao(apuracao)
          || this.indTodosMesesVigentes(apuracao))) {
        finalizaApuracao = true;
        indCriaRecebimento = false;
      }
      const datas = this.montarDataInicioFimApuracao(apuracao);

      if (apuracao.objRecebimentoDefinidoAlterado
          && (Object.values(apuracao.objRecebimentoDefinidoAlterado).length !== 0)) {
        apuracao.objRecebimentoDefinidoAlterado.dtaInicioPeriodo = datas.inicio;
        apuracao.objRecebimentoDefinidoAlterado.dtaFimPeriodo = datas.fim;
      }

      const objArmazenamento = {
        dataContabilizacao,
        indCriaRecebimento,
        idApuracao: apuracao.idApuracao,
        idTipoUso: apuracao.idTipoUsoNovo ? apuracao.idTipoUsoNovo : apuracao.idTipoUso,
        dataInicio: datas.inicio,
        dataFim: datas.fim,
        valorDigitado: apuracao.recebimentoDefinido,
        valorRecebimento: apuracao.recebimentoDefinido,
        valorBase: apuracao.indAcoesVerbasIguais ? apuracao.valorBaseCategoriaOriginal : apuracao.valorBase,
        valorBaseOriginal: apuracao.valorBaseOriginal,
        indImpressaoNdComHistorico: false,
        isFinalizarApuracao: finalizaApuracao,
        verba: apuracao.verba ? apuracao.verba : apuracao.faixaAtingida,
        objValorBaseAlterado: null,
        objRecebimentoDefinidoAlterado: apuracao.objRecebimentoDefinidoAlterado ? apuracao.objRecebimentoDefinidoAlterado : null,
        objTipoUsoAlterado: apuracao.objTipoUsoAlterado ? apuracao.objTipoUsoAlterado : null,
        codFornecedorAcao: apuracao.codFornecedorAcao ? apuracao.codFornecedorAcao : null,
      };
      return objArmazenamento;
    },
    montarDataInicioFimApuracao(apuracao) {
      const datas = {
        inicio: '',
        fim: '',
      };

      if (!apuracao.datasParciais) {
        if (this.periodoIntegralApuracao(apuracao)) {
          datas.inicio = moment(apuracao.dataInicio, 'DD-MM-YYYY').format('YYYY-MM-DD');
          datas.fim = moment(apuracao.dataFim, 'DD-MM-YYYY').format('YYYY-MM-DD');
          return datas;
        }
        const datasAux = this.verificaRetornaDatasValidas(apuracao);
        if (datasAux.length === 1) {
          datas.inicio = formatFirstDayOfTheMonth(moment(datasAux[0], 'YYYY-MM').format('MM-YYYY'), 'YYYY-MM-DD');
          datas.fim = formatlastDayOfTheMonth(moment(datasAux[0], 'YYYY-MM').format('MM-YYYY'), 'YYYY-MM-DD');
          return datas;
        }
        datas.inicio = formatFirstDayOfTheMonth(moment(datasAux[0], 'YYYY-MM').format('MM-YYYY'), 'YYYY-MM-DD');
        datas.fim = formatlastDayOfTheMonth(moment(datasAux[datasAux.length - 1], 'YYYY-MM').format('MM-YYYY'), 'YYYY-MM-DD');
        return datas;
      }

      if (apuracao.datasParciais) {
        const datasAux = this.verificaRetornaDatasValidas(apuracao);
        if (datasAux.length === 1) {
          datas.inicio = formatFirstDayOfTheMonth(moment(datasAux[0], 'YYYY-MM').format('MM-YYYY'), 'YYYY-MM-DD');
          datas.fim = formatlastDayOfTheMonth(moment(datasAux[0], 'YYYY-MM').format('MM-YYYY'), 'YYYY-MM-DD');
          return datas;
        }
        datas.inicio = formatFirstDayOfTheMonth(moment(datasAux[0], 'YYYY-MM').format('MM-YYYY'), 'YYYY-MM-DD');
        datas.fim = formatlastDayOfTheMonth(moment(datasAux[datasAux.length - 1], 'YYYY-MM').format('MM-YYYY'), 'YYYY-MM-DD');
        return datas;
      }
      return datas;
    },
    indTodosMesesVigentes(apuracao) {
      const mesesParciais = this.arrayMesesParciais(apuracao),
        mesesApuracao = this.arrayMesesApuracao(apuracao),
        mesesValidos = mesesApuracao.filter((mes) => !mesesParciais.includes(mes)),
        mesesFiltro = this.arrayMesesFiltros(),
        mesesVigentes = mesesFiltro.filter((mes) => mesesValidos.includes(mes));
      return mesesVigentes.length === mesesValidos.length;
    },
    periodoIntegralApuracao(apuracao) {
      const p1 = moment(apuracao.dataInicio, 'DD/MM/YYYY').format('YYYY-MM-DD'),
        p2 = moment(apuracao.dataFim, 'DD/MM/YYYY').format('YYYY-MM-DD'),
        pf1 = moment(this.filtros.dataInicio, 'YYYY-MM').format('YYYY-MM-DD'),
        pf2 = moment(this.filtros.dataFim, 'YYYY-MM').format('YYYY-MM-DD');
      if (moment(p1).isBetween(pf1, pf2, 'month', '[]')
        && moment(p2).isBetween(pf1, pf2, 'month', '[]')) {
        return true;
      }
      return false;
    },
    // peridosRestantesApuracao(apuracao) {

    // },
    verificaRetornaDatasValidas(apuracao) {
      let mesesParciais = [];
      let mesesFiltro = [];
      let mesesApuracao = [];
      let mesesValidos = [];

      if (apuracao.datasParciais) {
        mesesParciais = this.arrayMesesParciais(apuracao);
        mesesFiltro = this.arrayMesesFiltros();
        /* retira todos os meses iguais nos dois arrays e se sobrar mesesValidos verifica os meses de vigencia da apuração, ex:
        * array1: [2023/01, 2023/02, 2023/04, 2023/05, 2023/06]
        * array2: [2023/01, 2023/02, 2023/03, 2023/04, 2023/05, 2023/06, 2023/07]
        * result: [2023/03, 2023/07]
        */
        mesesValidos = mesesFiltro.filter((mes) => !mesesParciais.includes(mes));
        if (mesesValidos && mesesValidos.length) {
          /* se possuir pelo menos 1 mes dentro do range de datas da apuração já é o suficiente para criar apuração parcial */
          mesesApuracao = this.arrayMesesApuracao(apuracao);
          let mesesReais = [];
          mesesReais = mesesValidos.filter((mes) => mesesApuracao.includes(mes));
          return mesesReais || [];
        }
      } else {
        let mesesReais = [];
        mesesFiltro = this.arrayMesesFiltros();
        mesesApuracao = this.arrayMesesApuracao(apuracao);
        mesesReais = mesesFiltro.filter((mes) => mesesApuracao.includes(mes));
        return mesesReais || [];
      }
      return [];
    },
    arrayMesesParciais(apuracao) {
      /*
        * constroi um array com todas as datas(ano/mes) de apurações parcias da apuração, ex:
        * apuracao parcial 1: 01/02/2023 --- 28/02/2023
        * apuracao parcial 2: 01/04/2023 --- 30/06/2023
        * result [2023/01, 2023/02, 2023/04, 2023/05, 2023/06]
        */
      const mesesParciais = [];
      apuracao.datasParciais.split('|').forEach((el1) => {
        const meses = el1.split(','),
          mesInicio = moment(meses[0], 'DD/MM/YYYY').startOf('month'),
          mesFim = moment(meses[1], 'DD/MM/YYYY').startOf('month');
        while (mesFim.diff(mesInicio, 'months') >= 0) {
          mesesParciais.push(mesInicio.format('YYYY-MM'));
          mesInicio.add(1, 'month');
        }
      });
      return mesesParciais;
    },
    arrayMesesFiltros() {
      /*
        * constroi um array com todas as datas(ano/mes) do filtro aplicado em tela, ex:
        * filtro 2023/01 --- 2023/07
        * result [2023/01, 2023/02, 2023/03, 2023/04, 2023/05, 2023/06, 2023/07]
        */
      const mesesFiltro = [],
        mesInicioFiltro = moment(moment(this.filtros.dataInicio, 'YYYY-MM').format('DD/MM/YYYY'), 'DD/MM/YYYY').startOf('month'),
        mesFimFiltro = moment(moment(this.filtros.dataFim, 'YYYY-MM').format('DD/MM/YYYY'), 'DD/MM/YYYY').startOf('month');
      while (mesFimFiltro.diff(mesInicioFiltro, 'months') >= 0) {
        mesesFiltro.push(mesInicioFiltro.format('YYYY-MM'));
        mesInicioFiltro.add(1, 'month');
      }
      return mesesFiltro;
    },
    arrayMesesApuracao(apuracao) {
      const mesesApuracao = [],
        mesInicio = moment(apuracao.dataInicio, 'DD/MM/YYYY').startOf('month'),
        mesFim = moment(apuracao.dataFim, 'DD/MM/YYYY').startOf('month');
      while (mesFim.diff(mesInicio, 'months') >= 0) {
        mesesApuracao.push(mesInicio.format('YYYY-MM'));
        mesInicio.add(1, 'month');
      }
      return mesesApuracao;
    },
    prepararParametros() {
      const filtros = { ...this.filtros, ...this.filtrosComplementares };
      if (this.apuracoesSelecionadas.length) {
        const idsApuracao = [];
        const apuracoesRecebimentoDefinidoAlterado = [];
        const apuracoesTipoUsoAlterado = [];

        const apuracoesCodFornecedorAcao = [];

        this.apuracoesSelecionadas.forEach((apuracao) => {
          if (apuracao.selecionado) {
            idsApuracao.push(Number(apuracao.idApuracao));
            const dataInicio = moment(apuracao.dataInicio, 'DD/MM/YYYY').format('YYYY-MM-DD');
            const dataFim = moment(apuracao.dataFim, 'DD/MM/YYYY').format('YYYY-MM-DD');
            if (apuracao.objRecebimentoDefinidoAlterado
                && (Object.values(apuracao.objRecebimentoDefinidoAlterado).length !== 0)) {
              const valoresRecebimentoDefinido = {
                id_apuracao: Number(apuracao.objRecebimentoDefinidoAlterado.idApuracao),
                vlr_anterior: apuracao.objRecebimentoDefinidoAlterado.vlrAnterior,
                vlr_alterado: apuracao.objRecebimentoDefinidoAlterado.vlrAlterado,
                justificativa: apuracao.objRecebimentoDefinidoAlterado.justificativa,
                dta_inicio_periodo: dataInicio,
                dta_fim_periodo: dataFim,
              };
              apuracoesRecebimentoDefinidoAlterado.push(valoresRecebimentoDefinido);
            }
            if (apuracao.codFornecedorAcao
                && (Object.values(apuracao.codFornecedorAcao).length !== 0)) {
              const codFornecedorAcaoAlterado = {
                id_apuracao: Number(apuracao.idApuracao),
                cod_fornecedor_acao: apuracao.codFornecedorAcao,
              };
              apuracoesCodFornecedorAcao.push(codFornecedorAcaoAlterado);
            }
            if (apuracao.objTipoUsoAlterado
                && (Object.values(apuracao.objTipoUsoAlterado).length !== 0)) {
              const tipoUsoAlterado = {
                id: Number(apuracao.idApuracao),
                id_tipo_uso: Number(apuracao.idTipoUsoNovo),
                justificativa_tipo_uso: apuracao.justificativaTipoUso,
              };
              apuracoesTipoUsoAlterado.push(tipoUsoAlterado);
            }
          }
        });
        filtros.apuracoesSelecionadas = idsApuracao;
        filtros.apuracoesFornecedores = [];
        filtros.apuracoesRecebimentoDefinidoAlterado = apuracoesRecebimentoDefinidoAlterado.length ? apuracoesRecebimentoDefinidoAlterado : null;
        filtros.apuracoesCodFornecedorAcao = apuracoesCodFornecedorAcao.length ? apuracoesCodFornecedorAcao : null;
        filtros.apuracoesTipoUsoAlterado = apuracoesTipoUsoAlterado.length ? apuracoesTipoUsoAlterado : null;
        filtros.apuracoesValorBaseAlterado = null;
      }
      filtros.idTipoAcao = [filtros.tipoAcao];
      filtros.idGrupoFornecedor = filtros.id_grupo_fornecedor;
      filtros.dtaInicioApuracao = moment(filtros.dataInicio, 'YYYY-MM').format('YYYY-MM-DD');
      filtros.dtaFimApuracao = formatlastDayOfTheMonth(moment(filtros.dataFim, 'YYYY-MM').format('MM-YYYY'), 'YYYY-MM-DD');
      filtros.status = ['AGUARDANDO_APURACAO'];

      delete filtros.tipoAcao;
      delete filtros.id_grupo_fornecedor;
      delete filtros.dataInicio;
      delete filtros.dataFim;
      delete filtros.grupo_fornecedor;
      delete filtros.categoria;
      delete filtros.numeroPagina;
      delete filtros.tamanhoPagina;

      return filtros;
    },
    apuracaoPossuiInconsistencia(apuracao) {
      return (apuracao.indJustificativa && !apuracao.justificativaAlterarRecebimento)
      || (typeof apuracao.vlrRealizado === 'undefined' || apuracao.vlrRealizado === '')
      || !apuracao.possuiNota || !apuracao.existeAtingimento;
    },
    apuracaoPossuiInconsistenciaApuracoes(apuracao) {
      return (apuracao.vlrNdGerado === 0 && apuracao.recebimentoDefinido <= 0)
      || ((apuracao.periodicidade !== 'MENSAL' && !apuracao.possuiNota && apuracao.vlrNdGerado === 0))
      || (apuracao.periodicidade !== 'MENSAL' && apuracao.datasParciais && !this.verificaRetornaDatasValidas(apuracao).length)
      || (apuracao.vlrNdGerado > 0 && apuracao.recebimentoDefinido === 0 && (!this.indTodosMesesVigentes(apuracao)));
    },
    isformaBonificacaoFixo(apuracao) {
      return apuracao.formaBonificacao === 'FIXO';
    },
    handleIndExibirApuracoesZeradasAlterado(valor) {
      if (this.isAmbienteKabum) return;

      const filtrosLaterais = this.$refs.filtrosComplementares.$refs.filtrosRapidos.filtros;
      if (valor !== null && filtrosLaterais.ocultar_apuracao_sem_nota !== null) {
        filtrosLaterais.ocultar_apuracao_sem_nota = !valor;
      }
    },
  },
  mounted() {
    if (!this.canAccessPage) {
      window.setTimeout(() => this.accessForbidden(), 1E3);
    }
    this.buscarTiposUso();
  },
};
</script>
<style lang="scss">
.ApuracaoContrato_breadcrumbs-item_disabled {
  color: grey;
  pointer-events: none;
}
.ApuracaoContrato_breadcrumbs-item {
  color: grey;
  cursor: pointer;
}
.ApuracaoContrato_breadcrumbs-item:hover {
  color: #3f3f3f;
}
</style>
